import { render, staticRenderFns } from "./AssetsMaterialsForm.vue?vue&type=template&id=3991d59c&"
import script from "./AssetsMaterialsForm.vue?vue&type=script&lang=js&"
export * from "./AssetsMaterialsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports